import { Divider } from "antd";

const FooterLinks = () => {
  return (
    <div className="footer-links">
      © <a id="GovendaFooterLink" href="https://www.govenda.com" rel="noopener noreferrer">Govenda</a> {new Date().getFullYear()}
      <Divider type="vertical" />
      <a id="PrivacyPolicyLink" target="_blank" href="https://www.govenda.com/privacy" rel="noopener noreferrer">Privacy Policy</a>
      <Divider type="vertical" />
      <a id="CookiesLink" target="_blank" href="https://www.govenda.com/privacy" rel="noopener noreferrer">Cookies</a>
    </div>
  );
}

export default FooterLinks;